import { format } from 'date-fns'
import { useApiQuery } from 'hooks/useApiQuery'

interface UseGetFlexPayStatementsByIdParams {
  licensedEstablishmentIds: number[] | undefined
  currentPage: number
  pageSize: number
  type: any
  startDate: Date
  endDate: Date
  enabled?: boolean
  sortColumnName: string
  sortOrder: string
}

const formatDate = (d: Date) => format(d, 'yyyy-MM-dd')

export const useGetFlexPayStatements = ({
  licensedEstablishmentIds,
  currentPage,
  pageSize,
  type,
  startDate,
  endDate,
  sortColumnName,
  sortOrder,
  enabled = true,
}: UseGetFlexPayStatementsByIdParams) => {
  return useApiQuery({
    path: '/le-connect/flexpaystatements/{currentPage}/{pageSize}',
    method: 'get',
    queryKey: [
      'flexpaystatements',
      licensedEstablishmentIds,
      currentPage,
      pageSize,
      type,
      startDate,
      endDate,
      sortColumnName,
      sortOrder,
    ],
    queryArgs: {
      licensedEstablishmentIds,
      currentPage,
      pageSize,
      type,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      sortColumnName,
      sortOrder,
    },
    enabled,
  })
}
